import Chart from "react-apexcharts";

const PieChart = (props) => {
  const { series, options, height = "100%", width = "100%" } = props;

  return (
    <Chart
      options={options}
      type="pie"
      width={width}
      height={height}
      series={series}
    />
  );
};

export default PieChart;
